import { HelperService } from './helpers.service';
import { ErrorHandler, Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';
import * as firebase from 'firebase/app';
import { throttleTime, timeout } from 'rxjs/operators';
import { ILocation } from '../interface/location.interface.js';
import { Plugins } from '@capacitor/core';

const { Geolocation } = Plugins;

@Injectable({
  providedIn: 'root',
})
export class GeolocationService {
  location: ILocation;
  private watch;

  constructor(private firebaseService: FirebaseService, private helperS: HelperService) { }

  /* watchPosition(userId) {
    return this.watch = this.geolocation.watchPosition({enableHighAccuracy: true})
    .pipe(
      throttleTime(30000)
    )
    .subscribe((data: any) => {
      this.location = {
        ts: firebase.firestore.Timestamp.now().toMillis(),
        id: userId,
        latitude: data.coords.latitude,
        longitude: data.coords.longitude
      };
      this.firebaseService.addLocation(this.location);
      localStorage.setItem('lastLocation', JSON.stringify(this.location));
    });
  }
*/
  //  clearWatch() {
  //    this.watch.unsubscribe();
  //  }

  getCurrentPositionAssinatura(entregadorId, assinatura: boolean) {
    Geolocation.getCurrentPosition().then((res) => {
      this.location = {
        ts: firebase.firestore.Timestamp.now().toMillis(),
        latitude: res.coords.latitude,
        longitude: res.coords.longitude,
        id: entregadorId,
        assinatura,
      };

      this.firebaseService.addLocation(this.location);
    });
  }

  getCurrentPositionEntregaStart(pedidoId, entregadorId) {
    Geolocation.getCurrentPosition().then((res) => {
      this.location = {
        ts: firebase.firestore.Timestamp.now().toMillis(),
        latitude: res.coords.latitude,
        longitude: res.coords.longitude,
        id: entregadorId,
        pedido: pedidoId,
      };

      this.firebaseService.addLocation(this.location);
    });
  }
  sendFirebase(userId){
    return Geolocation.getCurrentPosition().then((res) => {
      this.location = {
        ts: firebase.firestore.Timestamp.now().toMillis(),
        latitude: res.coords.latitude,
        longitude: res.coords.longitude,
        id: userId,
      };
      this.firebaseService.addLocation(this.location);
    //  console.log('enviado firebase');
    });
  }

  getCurrentPositionCheckIn(entregadorId) {

    return Geolocation.getCurrentPosition({ enableHighAccuracy: true, timeout: 5000, maximumAge: 0 });
  //   }).catch((err) => {
  //     console.log(err.message);
  //     if (err.message === 'location unavailable') {
  //       this.helperS.toast('Erro em localizar sua posição, verifique se seu GPS está ligado e tente novamente.', 'warning');
  //       this.helperS.dismissLoader();
  //       return;
  //     }
  //   };);
  // } catch(error) {
  //   console.log(error);
  // }
  }
}
